import { render } from "./aFormHeader.vue?vue&type=template&id=28a0481e"
import script from "./aFormHeader.vue?vue&type=script&lang=js"
export * from "./aFormHeader.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__